export default "__VITE_ASSET__C11u9Xxi__"